<template>
    <nav aria-label="Paginator" v-if="isPaginable">
        <ul class="pagination mb-0">
            <li class="page-item" :class="{ disabled: isFirstPage }">
                <a class="page-link" href="#" aria-label="Previous" @click.prevent="firstPage()">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>
            <li class="page-item" v-for="page in paginator.last_page" v-if="(page >= (paginator.current_page - 3) && page <= (paginator.current_page + 3))" :class="{ active: (page == paginator.current_page) }">
                <a class="page-link" href="#" @click.prevent="moveTo(page)" v-text="page"></a>
            </li>
            <li class="page-item" :class="{ disabled: isLastPage }">
                <a class="page-link" href="#" aria-label="Next" @click.prevent="lastPage()">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>
        </ul>
    </nav>
</template>
<script>
    export default {

        props:{
            paginator:{
                required: true,
            },
        },

        methods:{

            moveTo(page){
                if(page != this.paginator.current_page) {
                    this.$emit('change', page)
                }
            },

            firstPage() {
                this.moveTo(1)
            },

            lastPage() {
                this.moveTo(this.paginator.last_page)
            },
        },

        computed:{
            isPaginable(){
                return !!this.paginator && (this.paginator.last_page > 1);
            },

            isFirstPage(){
                return !!this.paginator && (this.paginator.current_page == 1);
            },

            isLastPage(){
                return !!this.paginator && (this.paginator.last_page == this.paginator.current_page)
            }
        }
    }
</script>